import { Injectable, Input } from "@angular/core";
import { ControlValueAccessor } from "@angular/forms";
import { UnsubscribeOnDestroy } from "../classes";

@Injectable()
export abstract class SharedControl extends UnsubscribeOnDestroy implements ControlValueAccessor {
    // TODO: Skipped for migration because:
    //  Your application code writes to the input. This prevents migration.
    @Input() abstract disabled: boolean;
    isLoading: boolean = false;
    loadingText: string = "Loading...";

    propagateChange = (_: any) => { };
    propagateModelTouched = () => { };

    abstract writeValue(obj: any);

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.propagateModelTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}